module.exports = __webpack_public_path__ + "img/wz-5-8.55aabcab.png";